<!-- <app-template-select [disabled]="disabled" [value]="value" [control]="control" [options]="options" [multiple]="multiple" [label]="label" /> -->
<app-template-search (onblur)="onblur.emit()" [disabled]="disabled" [value]="value" [control]="control" [options]="options" [multiple]="multiple" [label]="label" />
